import React, { ReactNode, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import style from './Style.module.css';
import { useWindowSize } from 'usehooks-ts';
import Button from 'common/components/tags/button/Button';
import { subText } from 'common/utils/methods';
import clsx from 'clsx';
import Typography from 'common/components/tags/typography/Typography';

export interface props {
  title: string;
  href?: string;
  description?: string;
  className?: string;
  classNameHeader?: string;
  classNameBody?: string;
  classNameTitle?: string;
  iconColor?: string;
  heightBody?: string;
  children?: ReactNode;
}

const Accordion = ({
  title,
  href,
  description,
  className,
  classNameBody,
  classNameHeader,
  classNameTitle,
  heightBody,
  iconColor,
  children,
}: props) => {
  const [open, setOpen] = useState<boolean>(false);
  const { width } = useWindowSize();

  const handleOpen = () => {
    setOpen((old) => !old);
  };

  return (
    <div className={clsx(className, style.accordion)}>
      <div
        onClick={handleOpen}
        className={clsx(
          classNameHeader,
          open ? 'pb-0' : '',
          style['accordion-header']
        )}
      >
        <h3 className={clsx(style['accordion-title'], classNameTitle)}>
          {title}
        </h3>
        <IoIosArrowDown
          color={iconColor ?? '#006FFD'}
          size={width > 768 ? 25 : 20}
          className={`duration-300 ${open ? 'rotate-180' : ''}`}
        />
      </div>

      <div
        className={clsx(
          classNameBody,
          open
            ? `${heightBody ?? 'h-full'} duration-300`
            : `h-0 py-0 ${heightBody ? 'duration-300' : ''}`,
          style['accordion-body']
        )}
      >
        {/* children */}
        {children}

        {/* body */}
        {/* {description &&
          (href ? (
            <>
              <Typography variant="p4">{subText(description, 350)}</Typography>
              {description.length > 350 && (
                <Button
                  label="More About This "
                  iconClassName="arrow-right"
                  icon_align="right"
                  variant="text"
                  type="link"
                  path={href}
                  className="pl-0 text-[1.4rem]"
                />
              )}
            </>
          ) : (
            <Typography variant="p4">{description}</Typography>
          ))} */}

        <div>
          {Boolean(description) && (
            <Typography variant='p4' className='mr-3 inline'>
              {description}
            </Typography>
          )}
          {Boolean(href) && (
            <Button
              label='show more'
              iconClassName='arrow-right'
              icon_align='right'
              variant='text'
              type='link'
              target='_blank'
              path={href}
              className='pl-0 text-[1.4rem]'
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
